import { StoreFeaturesProps } from "@omni/types/components/props/storeFeatures.props";

import { Row } from "@/components/General/Grid/row.component";

import { StoreFeatures } from "./storeFeatures";

const StoreFeaturesDefault = ({ storeFeatures }: StoreFeaturesProps) => {
    return (
        <StoreFeatures storeFeatures={storeFeatures}>
            <StoreFeatures.Title />
            <Row>
                <StoreFeatures.FeatureList>
                    <StoreFeatures.FeatureList.Item />
                </StoreFeatures.FeatureList>
            </Row>
        </StoreFeatures>
    );
};

export { StoreFeaturesDefault };
